import { Component, OnInit, AfterViewInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';

import { AuthService } from '../shared/services/auth.service';
import { CookieManagerService } from '../shared/services/cookie-manager.service';

import { LoginUser } from '../modules/models'; // import module
import { SharedConstants } from '../shared/shared.const';

import { SpinnerService } from '../shared/services/spinner.service';

import { Constants } from '../app.const';
import * as CryptoJS from 'crypto-js';
import { MainConstants } from '../modules/main.const';

declare const gapi : any;

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {

  loginForm: FormGroup;
  url: string = "https://accounts.google.com/o/oauth2/auth?response_type=code&amp;redirect_uri=https%3A%2F%2Fint.crowderia.com%2Fsymfony%2Fweb%2Findex.php%2Fauth%2FvalidateCredentials%2Ffrom%2Fgoogle&amp;client_id=365711807340-bc7hfb63f02rl9vvr7s85tqob4qu0rc5.apps.googleusercontent.com&amp;scope=email&amp;access_type=online&amp;approval_prompt=auto";
  label: any;
  public loginUser: LoginUser = new LoginUser({});
  active: boolean;

  constructor(
    private formBuilder: FormBuilder,
    private activatedRoute: ActivatedRoute,
    private authService: AuthService,
    private cookieService: CookieManagerService,
    private router: Router,
    private spinner: SpinnerService
  ) {
    // spinner.status.subscribe((status: boolean) => {
    //   this.active = status;
    // });
  }

  ngOnInit() {
    this.initLoginForm();
  }

  ngAfterViewInit(){
    let auth2 : any;

    gapi.load('auth2', () => {
      auth2 = gapi.auth2.init({
        client_id : '892552957959-6lohdo5gfbp0a9pk58s2c4hd0ogfrs7u.apps.googleusercontent.com'
      });

      // auth2.attachClickHandler('gmLoginButton', {}, this.googleLoginSuccess.bind(this), this.googleLoginError.bind(this));
      auth2.attachClickHandler('gmLoginButton', {}, this.googleLoginSuccess.bind(this),
      this.googleLoginError.bind(this));
    });
  }

  /**
   * set task form group
   */
  initLoginForm() {
    this.loginForm = this.formBuilder.group({
      username: ['', Validators.required],// set the validation for username
      password: ['', Validators.required] // set the validation for password
    });
  }

  /**
   * validation
   */
  login() {
    if (this.loginForm.valid) {
      this.authService.logIn(this.loginUser.getPostData()).subscribe(
        this.loginSuccess.bind(this)
        ,
        this.loginError.bind(this)
      );
    } else {
      this.label = 'User Name and Password Required';
    }
  }

  loginSuccess(res){
    var userDetails = res.data;
    console.log(userDetails);
    let value = CryptoJS.AES.encrypt(JSON.stringify(userDetails), MainConstants.basicConstans.userKey).toString();
    this.cookieService.setCookie(MainConstants.basicConstans.userToken, value, false, 1);
    this.cookieService.setCookie(SharedConstants.basicConstans.cookieToken, res.data[SharedConstants.keyToken], false, 1);

    if(userDetails.user.is_client){
      window.location.href = Constants.clientAppUrl;
    }else{
      window.location.href = Constants.appUrl;
    }
  }

  loginError(error){
    this.label = 'Invalid credentials';
  }

  googleLoginSuccess(data){
    var profile = data.getBasicProfile();
    console.log('Email: ' + profile.getEmail());
    console.log('Token: ' + data.getAuthResponse().id_token);

    this.authService.loginWithGoogle({email : profile.getEmail(), token : data.getAuthResponse().id_token})
      .subscribe(this.loginSuccess.bind(this), this.loginError.bind(this));

  }

  googleLoginError(error){
    console.log(error);
    this.label = 'Google login failed';
  }


}



// WEBPACK FOOTER //
// ./src/app/login/login.component.ts